import React from "react";
import autoBind from "react-autobind";

import BaseComponent, { connect } from "@common/components/base.component";
import { getUrlByName } from "@common/router/router";
import urlUtils from "@common/helpers/url.utils";

class BreadCrumbItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      linkUrl: undefined
    };
    autoBind(this);
  }

  get linkUrl() {
    const { item } = this.props;

    if (item.link) {
      let targetUrl = getUrlByName(item.link);
      const { routerManager } = this.props;
      const linkUrl = urlUtils.setUrlParameters(targetUrl, routerManager.params, this.props.item.includeQueryString);
      return linkUrl;
    }
  }

  onClick() {
    const { routerManager } = this.props;
    routerManager.redirect({ url: this.linkUrl });
  }

  render() {
    const { linkUrl } = this;
    return (
      <li className={(this.props.active && "active") || ""}>
        {(linkUrl && <a onClick={this.onClick.bind(this)}>{this.props.item.text}</a>) || <span>{this.props.item.text}</span>}
      </li>
    );
  }
}

export default connect()(BreadCrumbItem);
